export default "__VITE_ASSET__2b05cd1d__"